module.exports = __webpack_public_path__ + "static/spar-434c7f3a6243607b10523326b2735391.png";